import React from 'react'
import Select from './Select'
import SelectItem from './SelectItem'

interface IProps {
  theme?: string
  className?: string
  name?: string
  error?: string
  value?: string
  clearable?: boolean
}

const SelectGame = ({
  theme = 'primary',
  className,
  ...props
}: IProps): React.ReactElement => {
  return (
    <Select placeholder='Выбери игру' theme={theme} className={className} {...props}>
      <SelectItem value='1'>Жэка “Квартира”</SelectItem>
      <SelectItem value='2'>Жэка “Дом”</SelectItem>
      <SelectItem value='3'>Жэка “Квартал”</SelectItem>
      <SelectItem value='4'>Жэка “Чистый город”</SelectItem>
      <SelectItem value='5'>Жэка “Урбанистика”</SelectItem>
    </Select>
  )
}

export default SelectGame
